import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom';
import '../assete/css/header.css'; 
import logo from "../assete/logo/LOGO-min.png";
import { Link } from 'react-router-dom';
import { FaAngleDown, FaTimes } from 'react-icons/fa';
import certificateImage from "../assete/certificate/SEA SENSE INTERDISCIPLINARY RESEARCH & IT SOLUTONS  9001 CA_page-0001.jpg";


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); 
  const [showPopup, setShowPopup] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [, setImageError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const header = document.getElementById('header');
      if (window.scrollY > 0) {
        header.classList.add('blue');
      } else {
        header.classList.remove('blue');
      }
      setMenuOpen(false);
      setOpenDropdown(null);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    setOpenDropdown(null);
  };

  const handleDropdownHover = (dropdown) => {
    setOpenDropdown(dropdown); // Open the hovered dropdown
  };

  const closeDropdown = () => {
    setOpenDropdown(null); // Close the dropdown when cursor moves away
  };
  const phd_peoposal = () => {
    navigate("");
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

   useEffect(() => {
          const handleRightClick = (e) => {
            e.preventDefault(); // This stops the right-click menu from opening
          };
      
          document.addEventListener("contextmenu", handleRightClick);
      
          // Cleanup when component unmounts
          return () => {
            document.removeEventListener("contextmenu", handleRightClick);
          };
        }, []);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };
  
 const handleCertificateClick = (e) => {
    e.preventDefault();
    setImageError(false);
    // Set your image URL here
     setImageUrl(certificateImage);
    setShowPopup(true);
  };

  const handleDownload = async () => {
    try {
      // Fetch the image and download it
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'certificate.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback method
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = 'certificate.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  
  return (
    <>

    <header className={`header ${menuOpen ? 'open' : ''}`} id="header">
      <div className="lg">
        <Link to="/Home"><img src={logo} alt="Logo" /></Link>
        <p>An ISO 9001:2015 certified company</p>
      </div>
      <div className="menu-icons" onClick={toggleMenu}>
      {menuOpen ? <FaTimes style={{color:"#066fb2",fontSize:"30px"}} />  : ( // Conditionally render the close icon if menuOpen is true
            <>
              <div className="menu-icon-bar"></div>
              <div className="menu-icon-bar"></div>
              <div className="menu-icon-bar"></div>
            </>
          )}
      </div>
      <nav className={`nav ${menuOpen ? 'open' : ''}`}>
        <div className='menus_add_line'>
        <ul>
        <li className={isActive("/Home")}>
            <Link to="/Home"   onClick={phd_peoposal}>Home </Link>
          </li>
          <li className={isActive("/About")}>
            <Link to="/About"   onClick={phd_peoposal}> About </Link>
          </li>
          <li className={isActive("/Service")}>
            <Link to="/Service"   onClick={phd_peoposal}> Service</Link>
          </li>
         
          <li  onMouseEnter={() => handleDropdownHover('research')}
                onMouseLeave={closeDropdown}>
             <div className="nav-item dropdown">
                                <Link to=""  className="nav-link dropdown-toggle"   >Research services <FaAngleDown /></Link>
                                <div className={`dropdown-menu rounded ${openDropdown === 'research' ? 'show' : ''}`}>
                                <div className='ctl' style={{background:"#066fb2",height:"5px",width:"100%",top:"0",marginTop:"-9px"}}>
                                   
                                   </div>
                                    <Link to="/Phdtopicselection"  className="dropdown-item"  onClick={phd_peoposal}>Research Topic Selection</Link>
                                    <Link to="/Researchproposal" className="dropdown-item"  onClick={phd_peoposal}>Research Proposal</Link>
                                    <Link to="/Literaturereview"  className="dropdown-item" onClick={phd_peoposal}>Literature Review</Link>
                                    <Link to="/Researchpaperwrite" className="dropdown-item"  onClick={phd_peoposal}>Research Paper Writting</Link>
                                    <Link to="/Implementation"  className="dropdown-item" onClick={phd_peoposal} >Implementation</Link>
                                    <Link to="/Journalassistance"  className="dropdown-item" onClick={phd_peoposal} >Journal Assistance</Link>
                                    <Link to="/Synopsisprepaation"  className="dropdown-item" onClick={phd_peoposal} >Synopsis Preparation</Link>
                                    <Link to="/Thesiswriting"  className="dropdown-item"  onClick={phd_peoposal}>Thesis Writing</Link>
                                </div>
                            </div> 
          </li>
          
          <li onMouseEnter={() => handleDropdownHover('development')}
                onMouseLeave={closeDropdown} >
             <div className="nav-item dropdown">
                                <Link to=""  className="nav-link dropdown-toggle" >Develpoment service  <FaAngleDown /></Link>
                                <div className={`dropdown-menu rounded ${openDropdown === 'development' ? 'show' : ''}`}>
                                <div className='ctl' style={{background:"#066fb2",height:"5px",width:"100%",top:"0",marginTop:"-9px"}}>
                                   
                                   </div>
                                    <Link to="/Matlabdevelopment"  className="dropdown-item" onClick={phd_peoposal}>Matlab Development</Link>
                                    <Link to="/Pythondevelopment" className="dropdown-item" onClick={phd_peoposal}>Python Development</Link>
                                    <Link to="/Javadevelopment"  className="dropdown-item" onClick={phd_peoposal}>Java Development</Link>
                                    <Link to="/VLSIdevelopment"  className="dropdown-item" onClick={phd_peoposal}>VLSI Development</Link>
                                    <Link to="/Seditdevelopment"  className="dropdown-item" onClick={phd_peoposal}>S-EDIT Development</Link>
                                    <Link to="/Ns2ns3development"  className="dropdown-item" onClick={phd_peoposal}>NS-2 & NS-3 Development</Link>
                                    <Link to="/Simulinkdevelopment"  className="dropdown-item" onClick={phd_peoposal}>Simulink Development</Link>
                                    <Link to="/Hfssdevelopment"  className="dropdown-item" onClick={phd_peoposal}s>HFSS Development</Link>
                                </div>
                            </div> 
          </li>

          <li onMouseEnter={() => handleDropdownHover('addons')}
                onMouseLeave={closeDropdown} >
             <div className="nav-item dropdown">
                                <Link to=""  className="nav-link dropdown-toggle"  >Add-On services <FaAngleDown /></Link>
                                
                                <div className={`dropdown-menu rounded ${openDropdown === 'addons' ? 'show' : ''}`}>
                                <div className='ctl' style={{background:"#066fb2",height:"5px",width:"100%",top:"0",marginTop:"-9px"}}>
                                   
                                   </div>
                                <Link to="/Plagiarismchecking"  className="dropdown-item" onClick={phd_peoposal}>Plagiarism Checking</Link>
                                    <Link to="/Grammarcheck" className="dropdown-item" onClick={phd_peoposal}>Grammer Checking</Link>
                                    <Link to="/Proofreading"  className="dropdown-item" onClick={phd_peoposal}>Proof Reading</Link>
                                    <Link to="/Language"  className="dropdown-item" onClick={phd_peoposal}>Language Correction</Link>
                                </div>
                            </div> 
          </li>
          
        
          <li className={isActive("/Payment")}>
            <Link to="/Payment"  onClick={phd_peoposal}>Payment Option</Link>
          </li>
          <li className={isActive("/Careers")}>
            <Link to="/Careers"  onClick={phd_peoposal}>Careers</Link>
          </li>
          
          <li className={isActive("/Contact")}>
            <Link to="/Contact"  onClick={phd_peoposal}>Contact</Link>
          </li>
           <li className={isActive("/Certificate")}>
            <Link to="/"  onClick={handleCertificateClick} className='certificete-btn' >Certificate</Link>
          </li>
          {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowPopup(false)}>
              ×
            </button>
           
            <img 
              src={imageUrl} 
              alt="Certificate" 
              className="certificate-image"
               onError={() => setImageError(true)}
            />
            
            <button className="download-btn" onClick={handleDownload}>
              Download Certificate
            </button>
          </div>
        </div>
      )}
          
          
        </ul>
        
        </div>
      </nav>
      
    </header>
    </>
  );
};

export default Header;
